import React, { FC } from "react";
import SectionGridFilterCard from "./SelectionGridFilterCard";

export interface ProductsPageProps {
	className?: string;
};

const ProductsPage: FC<ProductsPageProps> = ({ className = "" }) => {

	return (
		<div className={`nc-ProductsPage relative ${className}`}>
			
			{/* 商品卡片 */}
			<SectionGridFilterCard className="pb-24 lg:pb-32" />
		</div>
	)
};

export default ProductsPage;